import AbstractNumberValidator from '@/plugins/validator/number/AbstractNumberValidator'

export default class NumberValidator extends AbstractNumberValidator{

  constructor(fieldSchema, context, span){
    super()
    this.fieldSchema = fieldSchema
    this.context = context
    this.input = span
    this.value = span.textContent

  }

    getValue() {
        return this.input.textContent
    }

    getFieldValue(fieldInterface) {
        return this.context.getFieldValueById(fieldInterface.id)
    }

    getFieldInterface(id) {
        return this.context.getFieldInterface(id)
    }

}
